import script from "./GolfWeatherIntegrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./GolfWeatherIntegrationView.vue?vue&type=script&setup=true&lang=js"

import "./GolfWeatherIntegrationView.vue?vue&type=style&index=0&id=66edca64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66edca64"]])

export default __exports__